import apiClient from './apiClient';
import type { BugReport, BugStats, CreateBugReportRequest } from '../components/BugReport/types';

export interface BugFixLog {
  id: number;
  bugId: number;
  formId: string | null;
  page: string;
  action: string;
  diagnosis: string;
  rootCause: string;
  filesChanged: Array<{path: string; desc: string}>;
  result: string;
  notes: string;
  actor: string;
  createdAt: string;
}

export const bugReportApi = {
  async create(data: CreateBugReportRequest): Promise<BugReport> {
    const res = await apiClient.post('/api/dev/bugs', data);
    return res.data.data;
  },

  async list(params: {
    page?: number;
    size?: number;
    formId?: string;
    status?: string;
    pagePath?: string;
    reportedBy?: string;
  }): Promise<{ data: BugReport[]; total: number }> {
    const res = await apiClient.get('/api/dev/bugs', { params });
    return res.data;
  },

  async get(id: number): Promise<BugReport> {
    const res = await apiClient.get(`/api/dev/bugs/${id}`);
    return res.data.data;
  },

  async update(id: number, data: { status?: string; resolvedBy?: string; resolution?: string }): Promise<BugReport> {
    const res = await apiClient.put(`/api/dev/bugs/${id}`, data);
    return res.data.data;
  },

  async getStats(): Promise<BugStats> {
    const res = await apiClient.get('/api/dev/bugs/stats');
    return res.data.data;
  },

  async uploadScreenshot(file: File): Promise<{ url: string; fileId: string; fileName: string; fileSize: number }> {
    const formData = new FormData();
    formData.append('screenshot', file);
    const res = await apiClient.post('/api/dev/bugs/upload-screenshot', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },

  async listFixLogs(params: {
    page?: number;
    size?: number;
    bugId?: number;
    formId?: string;
    pagePath?: string;
  }): Promise<{ data: BugFixLog[]; total: number }> {
    const res = await apiClient.get('/api/dev/bug-fix-logs', { params });
    return res.data;
  },

  async getModuleBugHistory(formId: string): Promise<BugFixLog[]> {
    const res = await apiClient.get('/api/dev/bug-fix-logs/module', { params: { formId } });
    return res.data.data || [];
  },
};
